module.exports = __webpack_public_path__ + "img/amber-warning.9aefc9f0.svg";